import styled from 'styled-components';
import Image from '@stencil/image';
import {textSizes} from '@stencil/build-theme/src/build-theme';
import {PrimaryLink} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const Container = styled.section<{margin: string; minWidth: string}>(
  props => `
  display: flex;
  margin-top:${props.margin || '0'};
  min-width: ${props.minWidth || 'auto'};
  padding: ${props.theme.spacing.small} 0;
  position: sticky;
  top: 8.6rem;
`,
);

export const UGCPersuasionsAndBookingWidget = styled.div(
  props => `
  display: flex;
  width: ${props.width || '50%'};
  margin-top:${props.marginTop};
`,
);

export const SignUpPersuasionEMIBookingWidgetContainer = styled.section(
  props => `
  width: ${props.width || '50%'};
  margin-top:${props.marginTop};
  max-width: ${props.width || '50%'};
`,
);

// FBOFCAD Container – Free Breakfast or Free Cancellation and Deals Container
export const FBOFCADContainer = styled.aside(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  margin: 0 0 ${props.theme.spacing.base};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  // min-height:7rem;
  margin-top:${props.isVideo ? '10px' : 0};
`,
);

export const ViewMap = styled.div(
  props => `
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  border-radius: 1.2rem;
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.large} ;
  margin: 0 0 ${props.theme.spacing.custom(8)} 0;
  cursor: pointer;
  background-image: url('https://gos3.ibcdn.com/mapDweb-1638795011.png');
  height: 77px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`,
);

export const MapPin = styled(Image)(
  props => `
    width: 20.8px;
    height: 25px;
    align-self: center;
    flex-grow: 0;
    margin: 0 41.2px 5px 38px;
    object-fit: contain;
  `,
);

export const ViewMapCTA = styled.div(
  props => `
  font-size:${props.theme.font.custom(14)};
  color: ${props.theme.colors.goBrandBlue.base};
  background-color:${props.theme.colors.goBrandBlue.light};
  border-radius: 0.8rem;
  width: 100px;
  height: 30px;
  font-weight: 600;
  padding: 6px 15px 6px 14px;
`,
);

export const ColorBackgroundFromHermes = styled.div(
  props => `
  color: ${props.color ? props.color : props.theme.colors.downriver.base};
  background: ${props.background ? props.background : props.theme.colors.goWhite.base};
`,
);

export const FBOFCADText = styled(ColorBackgroundFromHermes)(
  props => `
  >span>span>div{
    padding:0;
  }
`,
);

export const FBOFCADDealText = styled(ColorBackgroundFromHermes)(
  props => `
  >span{
    display:flex;
    >span:nth-child(2) div span{
      max-width:18rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    >span{
      display:flex;
      >span:nth-child(2) div span{
        max-width:13rem;
      }
    }
  }
`,
);

export const CheckInCheckOutNewContainer = styled.div(
  props => `
  display:flex;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  padding:${props.theme.spacing.xlarge};
  margin-top: 13px
`,
);

export const CheckInCheckOutInner = styled.div(
  props => `
  margin-right:${props.theme.spacing.xxlarge};
`,
);

export const CheckInCheckOutLabel = styled.p(
  props => `
  color:${props.theme.colors.downriver.dark};
  margin-bottom:${props.theme.spacing.small};
`,
);

export const CheckInCheckOutTime = styled.span(
  props => `
  font-weight: 600;
  font-size: ${props.theme.font.large};
`,
);

export const ViewAllAmenities = styled(PrimaryLink)(
  props => `
  padding:0 ${props.theme.spacing.large};
  margin-bottom: ${props.theme.spacing.xlarge};
`,
);
export const MainWrapper = styled.div`
  position: relative;
  background: #ffffff;
  border-top: 0.1rem solid rgba(194, 194, 194, 0.3);
  margin-top: 1.2rem;
  border: 0.1rem solid #e8f3ff;
  border-radius: 1.2rem;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const HeaderPill = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0.6rem;
  margin: auto;
  width: 4rem;
  height: 0.4rem;
  background: #cbcbcb;
  border-radius: 0.8rem;
`;

export const HeaderWrapper = styled.div`
  overflow: hidden;
  padding: 0.6rem 0 1.2rem;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;
export const FeatureList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  overflow: scroll;
  gap: 1.2rem;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const SuperStarPill = styled.div`
  padding: 2px 6px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fa961a 19%, #ffb305 95%);
  ${textSizes.SmallW2};
  color: #fff;
`;

export const FeatureListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  ${textSizes.SmallW1};
  padding: 0.8rem;
  gap: 0.8rem;
  border: 0.1rem solid #e4e4e4;
  align-self: stretch;
  border-radius: 1.2rem;
  width: 24rem;
  flex-shrink: 0;
`;
export const HeaderText = styled.p`
  color: #222;
  ${textSizes.BaseW2};
  display: flex;
  align-items: center;
`;
export const ItemIconWrapper = styled.div`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;

  &.superStar {
    background: #fff6e5;
  }

  &.star {
    background: #ffeded;
  }
`;
export const Icon = styled.img`
  width: ${props => props.width || '100%'};
`;
export const ItemDisc = styled.div`
  width: 0.6rem;
  height: 0.6rem;
  transform: rotate(45deg);
  background: linear-gradient(315deg, #f8cd46 0%, #f4a900 100%);
`;

export const FeatureText = styled.p`
  ${textSizes.SmallW1};
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const OuterWrapperDiv = styled.section(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
  padding-bottom: 1rem;
`,
);
